<template>
    <div class="py-5">
        <b-card style="max-width: 600px" class="mx-auto text-left px-3 py-3">
            <h5 class="pb-3">Create new room</h5>
            <b-form-group   label="Room Name"
                            :state="errors.has('name')? false : null"
							:invalid-feedback="errors.first('name')"
            >
                <b-form-input 	name="name" 
								v-model="name" 
								@keyup.enter.native="login" 
								v-validate="'required'"
								:state="errors.has('name')? false : null"
								autofocus 
				/>
            </b-form-group>

            <div class="text-right">
                <b-btn variant="primary" class="mr-2" @click="createRoom">Create</b-btn>
                <b-btn :to="{ name: 'Dashboard' }">Cancel</b-btn>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: '',
        }
    },

    methods: {
		async createRoom() {
            this.$app.service('rooms').create({ name: this.name });
            this.$router.push({ name: 'Dashboard' });
        }

	}
}
</script>

